// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import RotateRightOutlinedSvg from "@fishx/icons-svg/es/asn/RotateRightOutlined";
import FishxIcon from '../components/FishxIcon';

var RotateRightOutlined = function RotateRightOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: RotateRightOutlinedSvg
  }));
};

RotateRightOutlined.displayName = 'RotateRightOutlined';
export default React.forwardRef(RotateRightOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/RotateRightOutlined.js
// module id = 4041
// module chunks = 0